import { useState } from "react";

export const PASSWORD_STORAGE_KEY = "driver-registrations-password";

export function readStoredPassword(): string {
    try {
        return localStorage.getItem(PASSWORD_STORAGE_KEY) ?? "";
    } catch {
        return "";
    }
}

// Read-only: the password is written to localStorage by AuthProvider's
// authenticate() at the point of a successful login.
export function usePassword(): string {
    const [password] = useState<string>(readStoredPassword);
    return password;
}
